/* eslint-disable react/no-array-index-key */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, FormGroup, Label } from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import { isRequired } from '../../../../utils/validators';
import FormItem from '../../../common/forms/FormItem';
import Loader from '../../../common/Loader';
import FormFooter from '../../../common/forms/FormFooter';
import CustomerSelect from '../../../common/forms/select/CustomerSelect';

export const DiscountCodeAuthorizerForm = ({ handleSubmit, loading }) => {
  if (loading) return <Loader />;

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup row>
        <FormItem label="Autorizador" required>
          <Field
            name="customerId"
            component={CustomerSelect}
            placeholder="Nombre"
            isDisabled
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem>
          <Label>
            <Field
              name="active"
              id="active"
              component="input"
              type="checkbox"
            />{' '}
            Activo
          </Label>
        </FormItem>
      </FormGroup>

      <FormFooter />
    </Form>
  );
};

DiscountCodeAuthorizerForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
};

DiscountCodeAuthorizerForm.defaultProps = {
  loading: false,
};

const mapStateToProps = (state) => ({
  loading: !state.SalesUnit.DiscountCodeCategory.getIn([
    'current',
    'activity',
  ]).isEmpty(),
});

const formComponent = reduxForm({
  form: 'DiscountCodeAuthorizerForm',
})(DiscountCodeAuthorizerForm);

export default connect(mapStateToProps, null)(formComponent);
